import { Link } from "react-router-dom"
import { useBrand } from "../../theme/useBrand"

export function Footer() {
  const brand = useBrand()
  return (
    <footer
      style={{
        background: "var(--bg)",
        borderTop: "1px solid rgba(255, 43, 79, 0.15)",
        padding: "48px 24px 32px",
      }}
    >
      <div className="mx-auto" style={{ maxWidth: "1200px" }}>
        <div className="grid gap-12 md:grid-cols-4 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div
                className="grid place-items-center"
                style={{
                  width: "32px",
                  height: "32px",
                  background: "rgba(18, 18, 20, 0.65)",
                  boxShadow: "inset 0 0 0 1px var(--rail)",
                }}
              >
                <img
                  src={brand.sprite}
                  width={16}
                  height={16}
                  className="pixel"
                  alt=""
                />
              </div>
              <span
                className="mono"
                style={{
                  fontSize: "14px",
                  letterSpacing: "0.14em",
                  textTransform: "uppercase",
                }}
              >
                {brand.name}
              </span>
            </div>
            <p className="text-sm" style={{ color: "var(--muted)", maxWidth: "240px" }}>
              Your AI back office that lives in your messages.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4
              className="mono text-xs mb-4"
              style={{
                letterSpacing: "0.16em",
                textTransform: "uppercase",
                color: "var(--muted)",
              }}
            >
              Product
            </h4>
            <ul className="grid gap-3">
              <li>
                <a href="#how-it-works" className="text-sm" style={{ color: "var(--text)" }}>
                  How It Works
                </a>
              </li>
              <li>
                <Link to="/pricing" className="text-sm" style={{ color: "var(--text)" }}>
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-sm" style={{ color: "var(--text)" }}>
                  Login
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4
              className="mono text-xs mb-4"
              style={{
                letterSpacing: "0.16em",
                textTransform: "uppercase",
                color: "var(--muted)",
              }}
            >
              Company
            </h4>
            <ul className="grid gap-3">
              <li>
                <Link to="/help" className="text-sm" style={{ color: "var(--text)" }}>
                  Help
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4
              className="mono text-xs mb-4"
              style={{
                letterSpacing: "0.16em",
                textTransform: "uppercase",
                color: "var(--muted)",
              }}
            >
              Legal
            </h4>
            <ul className="grid gap-3">
              <li>
                <Link to="/legal/privacy" className="text-sm" style={{ color: "var(--text)" }}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/legal/terms" className="text-sm" style={{ color: "var(--text)" }}>
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/legal/sms-terms" className="text-sm" style={{ color: "var(--text)" }}>
                  SMS Terms
                </Link>
              </li>
              <li>
                <Link to="/legal/sms-compliance" className="text-sm" style={{ color: "var(--text)" }}>
                  SMS Compliance
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div
          className="flex flex-wrap items-center justify-between gap-4 pt-8"
          style={{ borderTop: "1px solid rgba(255, 255, 255, 0.08)" }}
        >
          <p className="mono text-xs" style={{ color: "var(--muted)", letterSpacing: "0.08em" }}>
            &copy; {new Date().getFullYear()} Demons and Fairies Inc.
          </p>
          <p className="mono text-xs" style={{ color: "var(--muted)", letterSpacing: "0.08em" }}>
            SMS &bull; Voice &bull; Web
          </p>
        </div>

        {/* SMS Disclosure */}
        <div
          className="pt-6"
          style={{ borderTop: "1px solid rgba(255, 255, 255, 0.04)", marginTop: "24px" }}
        >
          <p
            className="text-xs"
            style={{ color: "var(--muted)", lineHeight: 1.6, maxWidth: "640px" }}
          >
            SMS notifications powered by Sales Demon. Message and data rates may apply.
            Message frequency varies based on account activity. Reply STOP to unsubscribe
            or HELP for assistance. See our{" "}
            <Link to="/legal/sms-terms" style={{ color: "var(--accent-text)", textDecoration: "underline" }}>
              SMS Terms
            </Link>{" "}
            and{" "}
            <Link to="/legal/privacy" style={{ color: "var(--accent-text)", textDecoration: "underline" }}>
              Privacy Policy
            </Link>
            .
          </p>
        </div>
      </div>
    </footer>
  )
}
